import { FC, Fragment } from 'react';
// component
import RowView from 'components/common/RowView';
// constants, interfaces
import { MACRO_NUTRIENT_TEXTS, MICRO_NUTRIENT_TEXTS } from 'constants/index';
import { FormulaNutrientWeightCardProps } from 'interfaces';

const FormulaNutrientsWeightsCard: FC<FormulaNutrientWeightCardProps> = ({
  macroNutrientsWeight,
  microNutrientsWeight,
}) => {
  // calculate weights of the macro nutrients

  const {
    protein,
    totalFat,
    calories,
    addedSugar,
    totalSugars,
    cholesterol,
    saturatedFat,
    dietaryFiber,
    carbohydrates,
  } = macroNutrientsWeight || {};

  const {
    // vitamins
    vitaminA,
    biotin,
    pantothenicAcid,
    thiamin,
    riboflavin,
    niacin,
    vitaminB6,
    vitaminB12,
    vitaminC,
    vitaminD,
    vitaminE,
    folate,
    vitaminK,
    vitaminK2,
    folicAcid,

    // minerals

    // macrominerals
    calcium,
    phosphorus,
    magnesium,
    sodium,
    potassium,
    chloride,

    // microminerals
    iron,
    zinc,
    iodine,
    selenium,
    copper,
    manganese,
    chromium,
    molybdenum,
    boron,

    // other
    choline,
  } = microNutrientsWeight || {};

  return (
    <Fragment>
      <RowView name={MACRO_NUTRIENT_TEXTS.calories} value={calories ? `${calories}` : ''} />
      <RowView name={`${MACRO_NUTRIENT_TEXTS.totalFat}`} value={totalFat ? `${totalFat} g` : ''} />
      <RowView
        name={`${MACRO_NUTRIENT_TEXTS.saturatedFat}`}
        value={saturatedFat ? `${saturatedFat} g` : ''}
      />
      <RowView name={MACRO_NUTRIENT_TEXTS.cholesterol} value={cholesterol ? `${cholesterol} g` : ''} />
      <RowView name={MACRO_NUTRIENT_TEXTS.carbohydrates} value={carbohydrates ? `${carbohydrates} g` : ''} />
      <RowView
        name={`${MACRO_NUTRIENT_TEXTS.dietaryFiber}`}
        value={dietaryFiber ? `${dietaryFiber} g` : ''}
      />
      <RowView name={MACRO_NUTRIENT_TEXTS.totalSugars} value={totalSugars ? `${totalSugars} g` : ''} />
      <RowView name={MACRO_NUTRIENT_TEXTS.addedSugar} value={addedSugar ? `${addedSugar} g` : ''} />
      <RowView name={MACRO_NUTRIENT_TEXTS.protein} value={protein ? `${protein} g` : ''} />
      {/* vitamins */}
      <RowView name={MICRO_NUTRIENT_TEXTS.vitaminA} value={vitaminA ? `${vitaminA} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.biotin} value={biotin ? `${biotin} mcg` : ''} />
      <RowView
        name={MICRO_NUTRIENT_TEXTS.pantothenicAcid}
        value={pantothenicAcid ? `${pantothenicAcid} mg` : ''}
      />
      <RowView name={MICRO_NUTRIENT_TEXTS.thiamin} value={thiamin ? `${thiamin} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.riboflavin} value={riboflavin ? `${riboflavin} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.niacin} value={niacin ? `${niacin} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.vitaminB6} value={vitaminB6 ? `${vitaminB6} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.vitaminB12} value={vitaminB12 ? `${vitaminB12} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.vitaminC} value={vitaminC ? `${vitaminC} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.vitaminD} value={vitaminD ? `${vitaminD} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.vitaminE} value={vitaminE ? `${vitaminE} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.folate} value={folate ? `${folate} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.vitaminK} value={vitaminK ? `${vitaminK} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.vitaminK2} value={vitaminK2 ? `${vitaminK2} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.folicAcid} value={folicAcid ? `${folicAcid} mg` : ''} />

      {/* macrominerals */}
      <RowView name={MICRO_NUTRIENT_TEXTS.calcium} value={calcium ? `${calcium} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.phosphorus} value={phosphorus ? `${phosphorus} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.magnesium} value={magnesium ? `${magnesium} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.sodium} value={sodium ? `${sodium} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.potassium} value={potassium ? `${potassium} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.chloride} value={chloride ? `${chloride} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.iron} value={iron ? `${iron} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.zinc} value={zinc ? `${zinc} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.iodine} value={iodine ? `${iodine} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.selenium} value={selenium ? `${selenium} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.copper} value={copper ? `${copper} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.manganese} value={manganese ? `${manganese} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.chromium} value={chromium ? `${chromium} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.molybdenum} value={molybdenum ? `${molybdenum} mg` : ''} />
      <RowView name={MICRO_NUTRIENT_TEXTS.boron} value={boron ? `${boron} mg` : ''} />

      {/* other */}
      <RowView name={MICRO_NUTRIENT_TEXTS.choline} value={choline ? `${choline} mg` : ''} />
    </Fragment>
  );
};

export default FormulaNutrientsWeightsCard;
